import React from 'react';

import BaseIcon, { type BaseIconProps } from '../BaseIcon';

const CrossIcon: React.FC<BaseIconProps> = ({ ...rest }) => {
  return (
    <BaseIcon {...rest} viewBox="0 0 20 20" fill="none">
      <path
        d="M15 5L5 15M5 5L15 15"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default CrossIcon;
